import { Button, Typography } from '@/components';
import { TextStyles } from '@/constants';
import { ButtonVariant } from '@/interfaces';
import styled from 'styled-components';

export const DeleteSuccessWrapper = styled.div(({ theme }) => ({
  paddingInline: theme.spacing[32],
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.colors.pageBackground,
  minHeight: 587,
}));

export const Title = styled(Typography).attrs({
  variant: TextStyles['Heading 1'],
})(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
  marginBottom: theme.spacing[8],
  textAlign: 'center',
}));

export const BackToHomeButton = styled(Button).attrs({
  variant: ButtonVariant.Link,
})(({ theme }) => ({
  padding: `${theme.spacing[8]} ${theme.spacing[10]}`,
  wordBreak: 'break-word',
  textAlign: 'center',
}));
